export default __webpack_public_path__ + "static/media/proximanova-regular.0a329f58.otf";